import { useImportHubV2 } from '../../../hooks/ff/index.js';
import { TemplateContextFieldsV1 } from './TemplateContextFieldsV1.jsx';
import { TemplateContextFieldsV2 } from './TemplateContextFieldsV2.jsx';
import type { TemplateDuplicationFormState } from './types.js';

type ContextFieldsProps = {
  state: TemplateDuplicationFormState;
};

export const TemplateContextFields = ({ state }: ContextFieldsProps) => {
  const isImportHubV2 = useImportHubV2();

  if (isImportHubV2) {
    return <TemplateContextFieldsV2 state={state} />;
  }

  return <TemplateContextFieldsV1 state={state} />;
};
